<template>
  <div class="layout-wrap">
    <div class="wrap clearfix">
      <div class="nav">
        <div class="logo" @click="handleReturnHome">
          <img v-if="$store.state.logoUrl" :src="$store.state.logoUrl">
          <div v-else>{{ $store.state.name }}</div>
        </div>
        <div class="nav-right">
          <ul>
            <router-link :to="{name: 'index',params: {url: url}}" tag="li">首页</router-link>
            <router-link :to="{name: 'announcement'}" tag="li">信息公告</router-link>
            <router-link :to="{name: 'assessLayout'}" tag="li">心理测评</router-link>
            <!-- <router-link :to="{name: 'consult'}" tag="li">心理咨询</router-link> -->
            <router-link :to="{name: 'videoLayout'}" tag="li">心理课件</router-link>
          </ul>
          <div class="user-wrap" @mouseover="handleMouseover" @mouseout="handleMouseout">
            <div class="user-notLog">
              <img src="@/assets/images/avatar.png" alt="">
              <span v-if="!trueName">请您登录</span>
              <span v-else>{{trueName}} {{organizationName}}</span>
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div class="user-log" v-show="loginBoxShow">
              <i class="triangle el-icon-caret-top"></i>
              <p class="line"></p>
              <router-link v-if="!trueName" class="login-btn" to="/loginLayout" tag="p">登录</router-link>
              <div class="amend" v-else>
                <router-link class="login-btn" to="/changePwd" tag="p"><img src="@/assets/images/icon_lock.png" alt="" /> 修改密码</router-link>
                <p @click="handleQuit" class="login-btn"><img src="@/assets/images/icon_out.png" alt="" />退出</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <transition name="slide-left">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </transition>
      </div>
    </div>
    <div class="footer-wrap">
      <div class="footer-top">
        <div class="footer-item">
          <img class="icon" src="@/assets/images/icon.png" alt="">
          <div>
            <p>电话：</p>
            <p>0351-4959252</p>
            <!-- <p>15095170893</p> -->
          </div>
        </div>
        <div class="footer-item">
          <img class="www" src="@/assets/images/www.png" alt="">
          <div>
            <p>网址：</p>
            <p style="cursor: pointer;" @click="jumpXinlicloud">www.wendao12.com</p>
          </div>
        </div>
        <div class="footer-item">
          <img class="dizhi" src="@/assets/images/dizhi.png" alt="">
          <div>
            <p>地址：</p>
            <p>山西省太原市迎泽区水西门街馒头巷7号山西教育出版社</p>
          </div>
        </div>
      </div>
      <div class="footer-bottom"><span @click="jumpBeian">晋ICP备17003283号-1</span>  山西出版传媒集团股份有限公司山西教育出版社分公司版权所有</div>
    </div>
  </div>
</template>

<script>
import {GetAuthority, Logout, RemoveAuthority} from '../authority';
export default {
  data () {
    return {
      logoUrl: localStorage.getItem('logoUrl'),
      loginBoxShow: false,
      trueName: GetAuthority('pcs_true_name') ? GetAuthority('pcs_true_name') : '',
      url: window.localStorage.getItem('pcs_org_abbr') ? window.localStorage.getItem('pcs_org_abbr') : 'xnt',
      organizationName: GetAuthority('pcs_org_name') ? GetAuthority('pcs_org_name') : ''
    };
  },
  methods: {
    jumpBeian () {
      window.open('https://beian.miit.gov.cn/');
    },
    jumpXinlicloud () {
      window.open(' https://www.wendao12.com');
    },
    handleMouseover () {
      this.loginBoxShow = true;
    },
    handleMouseout () {
      this.loginBoxShow = false;
    },
    handleQuit () {
      Logout();
      RemoveAuthority();
      this.userName = '';
      this.orgName = '';
      this.$router.push({
        name: 'login'
      });
    },
    handleReturnHome () {
      this.$router.push({
        name: 'index',
        params: {
          url: window.localStorage.getItem('pcs_org_abbr')
        }
      });
    }
  },
  computed: {
  }
};
</script>

<style lang="scss" scoped>
.layout-wrap {
  background: #fff;
  width: 100%;
  height: 100%;
  .nav {
    @include container(1200px);
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo{
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        max-height: 60px;
      }
    }
  }
  .nav-right {
    display: flex;
    ul {
      display: flex;
      align-items: center;
      li {
        cursor: pointer;
        padding: 0 22px;
        color: #333;
        &.router-link-active {
          color: $el-main-color;
        }
        &:hover {
          color: $el-main-color;
        }
      }
    }
    .user-wrap {
      height: 85px;
      margin-left: 20px;
      position: relative;
      .user-notLog {
        display: flex;
        align-items: center;
        color: #333;
        cursor: pointer;
        line-height: 85px;
        img {
          width: 26px;
          height: 26px;
          margin-right: 12px;
        }
        span {
          margin-right: 3px;
        }
      }
      .user-log {
        width: 146px;
        position: absolute;
        top: 75px;
        left: 50%;
        margin-left: -83px;
        box-shadow: 0px 0px 10px rgba(28,87,222,.53);
        border-radius: 5px;
        padding: 0 13px;
        z-index: 10;
        background: #fff;
        .triangle {
          color: #fff;
          font-size: 35px;
          text-shadow: 0px -2px 5px rgba(28,87,222,.53);
          position:absolute;
          top:-24px;
          left: 50%;
          transform: translate(-50%, 0%);
        }
        .line {
          background: #fff;
          width: 30px;
          height: 4px;
          position:absolute;
          top:0px;
          left: 50%;
          transform: translate(-50%, 0%);
          z-index: 10;
        }
        .login-btn {
          height: 43px;
          line-height: 43px;
          color: #666;
          cursor: pointer;
          &:hover {
            color: $el-main-color;
          }
        }
        .amend {
          .login-btn {
            height: 43px;
            line-height: 43px;
            color: #666;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #f5f5f5;
            cursor: pointer;
            &:hover {
              color: $el-main-color;
            }
            img{
              width: 26px;
              height: 26px;
              margin-right:10px;
            }
          }
        }
      }
    }
  }
  .wrap {
    min-height:100%;
    width:100%;
  }
  .main{
    padding-bottom:120px;
  }
  .clearfix::after {
    display: block;
    content: ".";
    clear: both;
    visibility: hidden;
  }
  .footer-wrap {
    margin:-120px auto 0;
    height: 120px;
    background: url(../assets/images/footer.png) no-repeat center;
    background-size: cover;
    color: #fff;
    overflow: hidden;
    .footer-top {
      margin: 25px 0 0 0;
      display: flex;
      justify-content: space-around;
      .footer-item{
        display: flex;
        font-size: 14px;
        .icon{
          width: 11px;
          height: 18px;
          margin-right: 20px;
          margin-top: 4px;
        }
        .www{
          width: 16px;
          height: 16px;
          margin-right: 20px;
          margin-top: 4px;
        }
        .dizhi {
          width: 17px;
          height: 18px;
          margin-right: 20px;
          margin-top: 4px;
        }
        .footer-icon{
          display: block;
          margin-top: 4px;
          margin-right: 20px;
          font-size: 20px;
        }
      }
    }
    .footer-bottom {
      text-align: center;
      font-size: 14px;
      margin-top:30px;
    }
  }
}
@keyframes slideInLeft {
  from {
    transform: translateY(20PX);
    opacity: 0;
  }
  to {
    transform: translateY(0PX);
    opacity: 1;
  }
}

@keyframes slideLeftOut {
  from {
    transform: scale(0.5);
  }
  to {
    transform: scale(0);
  }
}
.slide-left-enter-active {
  animation: slideInLeft 1s forwards;
  z-index:5;
}
</style>



// WEBPACK FOOTER //
// src/layout/layout.vue